import React, { useState, useContext } from 'react';
import { Like1, Message } from 'iconsax-react';
import { ThemeContext } from '../theme';

const SCALE = 0.75;
const s = (n) => Math.round(n * SCALE);

export default function CommunityPostCard({ avatar, name, date, text, time }) {
  const theme = useContext(ThemeContext);
  const [liked, setLiked] = useState(false);

  return (
    <div
      style={{
        backgroundColor: theme.cardBg,
        borderRadius: s(20),
        padding: s(16),
        display: 'flex',
        flexDirection: 'column',
        gap: s(24),
        width: s(360),
        flexShrink: 0,
        boxSizing: 'border-box',
      }}
    >
      {/* Header: avatar + name + date */}
      <div style={{ display: 'flex', alignItems: 'center', gap: s(12) }}>
        <img
          src={avatar}
          alt={name}
          style={{ width: s(44), height: s(44), borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
        />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span className="font-satoshi font-bold" style={{ fontSize: s(18), lineHeight: `${s(24)}px`, color: theme.text100 }}>
            {name}
          </span>
          <span className="font-satoshi" style={{ fontSize: s(14), lineHeight: '1.6', color: theme.text400, fontWeight: 500 }}>
            {date}
          </span>
        </div>
      </div>

      {/* Post text */}
      <p
        className="font-satoshi"
        style={{ margin: 0, fontSize: s(18), lineHeight: `${s(24)}px`, color: theme.text100, fontWeight: 400 }}
      >
        {text}
      </p>

      {/* Footer: time + action icons */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span className="font-satoshi" style={{ fontSize: s(14), lineHeight: '1.6', color: theme.text400, fontWeight: 500 }}>
          {time}
        </span>
        <div style={{ display: 'flex', gap: s(16), alignItems: 'center' }}>
          <button
            onClick={() => setLiked(l => !l)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex' }}
          >
            <Like1 size={s(24)} variant={liked ? 'Bold' : 'Linear'} color={liked ? theme.btnPrimaryBg : theme.text400} />
          </button>
          <button style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex' }}>
            <Message size={s(24)} variant="Linear" color={theme.text400} />
          </button>
        </div>
      </div>
    </div>
  );
}
